import { Chip, Tooltip, Typography } from '@mui/material'
import { lighten } from '@mui/system'
import React from 'react'

import { AutocompleteSearchOption } from 'types/forms'

function getChipColor(isSelected, isUnhealthy, muiTheme) {
  if (!isSelected && isUnhealthy) {
    return muiTheme.palette.error.main
  }

  if (isSelected && isUnhealthy) {
    return lighten(muiTheme.palette.error.main, 0.25)
  }

  if (isSelected && !isUnhealthy) {
    return muiTheme.palette.primary.main
  }

  if (!isSelected && !isUnhealthy) {
    return 'default'
  }
}

export const ServiceTagLabelSectionListItem: React.FC<{
  option: AutocompleteSearchOption
  isSelected: boolean
  isUnhealthy: boolean
  handleSelectOption(e, option): void
}> = ({ option, isSelected, isUnhealthy, handleSelectOption }) => {
  return (
    <Tooltip arrow placement="top" title={option.label}>
      <Chip
        data-test-target-is-selected={isSelected}
        data-test-target-is-unhealthy={isUnhealthy}
        data-test-target-param-value={option.params?.value}
        label={
          <Typography
            noWrap
            fontFamily="monospace"
            sx={(muiTheme) => ({
              color: getChipColor(isSelected, isUnhealthy, muiTheme)
            })}
            variant="caption"
          >
            {option.label}
          </Typography>
        }
        size="small"
        sx={(muiTheme) => ({
          borderColor: getChipColor(isSelected, isUnhealthy, muiTheme),
          padding: 1,
          maxWidth: 256
        })}
        variant="outlined"
        onClick={(e) => handleSelectOption(e, option)}
      />
    </Tooltip>
  )
}
